import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@components/Text';
import {
  Wrapper,
  Title,
  Body,
  Buttons,
  ConfirmButton,
  CancelButton,
} from './styles';

const onButtonClicked = (onClose, onConfirm, result) => () => {
  onConfirm(result);
  onClose();
};

const Confirm = ({
  titleText,
  bodyText,
  confirmText,
  cancelText,
  onClose,
  onConfirm,
  icon,
  confirmOnEnter,
}) => {
  useEffect(() => {
    if (!confirmOnEnter) return;

    const handler = (e) => {
      if (e?.key !== 'Enter') return;

      const tag = e?.target?.tagName ? String(e.target.tagName).toUpperCase() : '';
      // Safety: don't hijack Enter inside input fields.
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;

      e.preventDefault?.();
      onConfirm(true);
      onClose();
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [confirmOnEnter, onClose, onConfirm]);

  return (
    <Wrapper>
      {icon}
      <Title>
        <Text size={TEXT_SIZE.T0} textColor={TEXT_COLOR.DARK_BLUE} weight='900'>
          {titleText}
        </Text>
      </Title>
      {bodyText && (
        <Body>
          <Text size={TEXT_SIZE.T3} textColor={TEXT_COLOR.DISABLED}>
            {bodyText}
          </Text>
        </Body>
      )}
      <Buttons>
        <ConfirmButton
          className='confirmButton'
          onClick={onButtonClicked(onClose, onConfirm, true)}
        >
          {confirmText}
        </ConfirmButton>
        <CancelButton
          cancel
          className='cancelButton'
          onClick={onButtonClicked(onClose, onConfirm, false)}
        >
          {cancelText}
        </CancelButton>
      </Buttons>
    </Wrapper>
  );
};

Confirm.propTypes = {
  onClose: PropTypes.func,

  onConfirm: PropTypes.func,
  titleText: PropTypes.node,
  bodyText: PropTypes.node,
  confirmText: PropTypes.node,
  cancelText: PropTypes.node,
  confirmOnEnter: PropTypes.bool,
};

Confirm.defaultProps = {
  confirmOnEnter: false,
};

export default Confirm;
